import api from 'Api'
import { SET_MESSAGE } from '../components/utils'
import moment from 'moment'
const URL = '/scans/organization/'
const URL_SCANS_STATS = '/scan-stats/'

const state = {
  scans: [],
  isLoading: false,
  scansStats: {}
}

const getters = {
  scans: state => {
    return state.scans
  },
  scanLoader (state) {
    return state.isLoading
  },
  scansStats: state => {
    return state.scansStats
  }
}

const actions = {
  async load_scans (context, payload) {
    if (!payload) return
    context.commit('setScansLoading', true)
    let response
    try {
      response = await api().get(`${URL}${payload}`)
      response.data.map(s => {
        if (s.start_time) {
          const start = moment.utc(s.start_time, 'YYYY-MM-DD HH:mm:ss').local()
          s.start_time = moment(start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm A')
        } else {
          s.start_time = '-'
        }
        if (s.end_time) {
          const end = moment.utc(s.end_time, 'YYYY-MM-DD HH:mm:ss').local()
          s.end_time = moment(end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm A')
        } else {
          s.end_time = '-'
        }
      })
      context.commit('scansLoaded', response.data)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    context.commit('setScansLoading', false)
  },
  async load_scan_stats (context, scanId) {
    if (!scanId) return
    let response = {}
    try {
      response = await api().get(`${URL_SCANS_STATS}${scanId}`)
      response.data.sort((a, b) => {
        return (a.last_updated < b.last_updated) ? -1 : ((a.last_updated > b.last_updated) ? 1 : 0)
      })
      response.data.map(s => {
        if (s.last_updated) {
          s.last_updated = moment.utc(s.last_updated, 'YYYY-MM-DD HH:mm:ss').local().toISOString()
        } else {
          s.last_updated = '-'
        }
      })
      context.commit('scansStatsLoaded', { scanId, data: response.data })
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
  }
}

const mutations = {
  scansData (state, scan) {
    if (scan.start_time) {
      const start = moment.utc(scan.start_time, 'YYYY-MM-DD HH:mm:ss').local()
      scan.start_time = moment(start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm A')
    } else {
      scan.start_time = '-'
    }
    if (scan.end_time) {
      const end = moment.utc(scan.end_time, 'YYYY-MM-DD HH:mm:ss').local()
      scan.end_time = moment(end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD hh:mm A')
    } else {
      scan.end_time = '-'
    }
    const index = state.scans.findIndex(s => s.entity_id === scan.entity_id)
    if (state.scans[index] && state.scans[index].isCanceled) {
      scan.current_status = 'Canceled'
      scan.isCanceled = true
    }
    index > -1 ? state.scans.splice(index, 1, scan) : state.scans.push(scan)
  },
  setScansLoading (state, payload) {
    state.isLoading = payload
  },
  scansLoaded (state, scans) {
    state.scans = scans
  },
  scansStatsLoaded (state, payload) {
    state.scansStats[payload.scanId] = payload.data
    state.scansStats = { ...state.scansStats }
  },
  addScanStats (state, scan) {
    if (state.scansStats[scan.scan_id]) {
      state.scansStats[scan.scan_id].push(scan)
    } else {
      state.scansStats[scan.scan_id] = [scan]
    }
  },
  cancelScan (state, scan) {
    const index = state.scans.findIndex(s => s.entity_id === scan.entity_id)
    if (index > -1) {
      state.scans[index] = scan
    }
  },
  resetScans (state) {
    state.scans = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'scanStore'
}
